if (!customElements.get('op-quiz-olfativo')) {
  class OpQuizOlfativo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';

      this.api = this.dataset.api || '/apps/op-buscador';
      this.dialog = this.querySelector('[data-op-quiz-dialog]');
      this.bodyEl = this.querySelector('[data-op-quiz-body]');
      this.featured = (this.dataset.featured || '').split(',').map((h) => h.trim()).filter(Boolean);
      this.featuredMax = Number(this.dataset.featuredMax) || 1;
      this.questions = null;
      this.answers = {};
      this.step = 0;

      this.querySelectorAll('[data-op-quiz-open]').forEach((el) => el.addEventListener('click', () => this.open()));
      const close = this.querySelector('[data-op-quiz-close]');
      if (close) close.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      const trigger = (this.dataset.trigger || '').trim();
      if (trigger) {
        document.addEventListener('click', (event) => {
          const target = event.target instanceof Element ? event.target.closest(trigger) : null;
          if (target && !this.contains(target)) {
            event.preventDefault();
            this.open();
          }
        });
      }
    }

    label(name) {
      return this.dataset[name] || '';
    }

    esc(value) {
      const div = document.createElement('div');
      div.textContent = value == null ? '' : String(value);
      return div.innerHTML;
    }

    money(value) {
      return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(value);
    }

    open() {
      this.answers = {};
      this.step = 0;
      if (!this.dialog.open) this.dialog.showModal();

      if (this.questions) {
        this.renderQuestion();
        return;
      }
      this.bodyEl.innerHTML = '<p class="op-quiz__status">' + this.esc(this.label('loadingText')) + '</p>';
      fetch(this.api + '/quiz')
        .then((res) => {
          if (!res.ok) throw new Error('API respondió ' + res.status);
          return res.json();
        })
        .then((data) => {
          this.questions = data.questions || [];
          this.renderQuestion();
        })
        .catch(() => {
          this.bodyEl.innerHTML = '<p class="op-quiz__status">' + this.esc(this.label('errorText')) + '</p>';
        });
    }

    renderQuestion() {
      const question = this.questions[this.step];
      const progress = this.label('stepText')
        .replace('{current}', String(this.step + 1))
        .replace('{total}', String(this.questions.length));
      const options = question.options
        .map(
          (option) =>
            '<button type="button" class="op-quiz__option" data-option="' + this.esc(option.id) + '">' + this.esc(option.label) + '</button>'
        )
        .join('');
      const back = this.step > 0 ? '<button type="button" class="op-quiz__back" data-back>' + this.esc(this.label('backLabel')) + '</button>' : '';

      this.bodyEl.innerHTML =
        '<p class="op-quiz__progress">' + this.esc(progress) + '</p>' +
        '<h3 class="op-quiz__question">' + this.esc(question.title) + '</h3>' +
        '<div class="op-quiz__options">' + options + '</div>' + back;

      this.bodyEl.querySelectorAll('[data-option]').forEach((button) =>
        button.addEventListener('click', () => this.choose(question.id, button.dataset.option))
      );
      const backButton = this.bodyEl.querySelector('[data-back]');
      if (backButton) {
        backButton.addEventListener('click', () => {
          this.step -= 1;
          this.renderQuestion();
        });
      }
      const first = this.bodyEl.querySelector('.op-quiz__option');
      if (first) first.focus();
    }

    choose(questionId, optionId) {
      this.answers[questionId] = optionId;
      if (this.step + 1 < this.questions.length) {
        this.step += 1;
        this.renderQuestion();
      } else {
        this.submit();
      }
    }

    submit() {
      this.bodyEl.innerHTML = '<p class="op-quiz__status">' + this.esc(this.label('loadingText')) + '</p>';
      fetch(this.api + '/quiz/result', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(
          this.featured.length ? { answers: this.answers, featured: this.featured, featured_max: this.featuredMax } : { answers: this.answers }
        ),
      })
        .then((res) => {
          if (!res.ok) throw new Error('API respondió ' + res.status);
          return res.json();
        })
        .then((data) => this.renderResults(data))
        .catch(() => {
          this.bodyEl.innerHTML = '<p class="op-quiz__status">' + this.esc(this.label('errorText')) + '</p>';
        });
    }

    addButton(product) {
      if (!product.variant_id || product.in_stock === false) return '';
      return (
        '<button type="button" class="op-res__add" data-op-add data-variant="' + this.esc(product.variant_id) + '"' +
        ' data-adding-label="' + this.esc(this.label('addingLabel')) + '"' +
        ' data-done-label="' + this.esc(this.label('addedLabel')) + '"' +
        ' data-error-label="' + this.esc(this.label('addErrorLabel')) + '">' +
        this.esc(this.label('addLabel')) + '</button>'
      );
    }

    card(product) {
      const old = product.compare_at_price ? '<span class="op-res__old">' + this.money(product.compare_at_price) + '</span>' : '';
      const off = product.discount_pct ? '<span class="op-res__off">-' + this.esc(product.discount_pct) + '%</span>' : '';
      const out = product.in_stock === false ? '<span class="op-res__out">Agotado</span>' : '';
      const why = product.why && product.why.length ? '<span class="op-res__why">' + this.esc(product.why.slice(0, 2).join(' · ')) + '</span>' : '';
      const img = product.image
        ? '<img class="op-res__img" src="' + this.esc(product.image) + '" alt="' + this.esc(product.title) + '" loading="lazy" width="320" height="320">'
        : '<span class="op-res__img"></span>';
      return (
        '<div class="op-res__card">' +
        '<a class="op-res__link" href="' + this.esc(product.url) + '">' +
        '<span class="op-res__media">' + img + off + out + '</span>' +
        '<span class="op-res__title">' + this.esc(product.title) + '</span>' + why +
        '<span class="op-res__price">' + old + '<span class="op-res__now">' + this.money(product.price) + '</span></span></a>' +
        this.addButton(product) +
        '</div>'
      );
    }

    renderEmailForm() {
      const wrap = document.createElement('form');
      wrap.className = 'op-quiz__lead';
      wrap.innerHTML =
        '<p class="op-quiz__lead-title">' + this.esc(this.label('emailTitle')) + '</p>' +
        '<input class="op-quiz__lead-input" type="email" required maxlength="120" autocomplete="email" placeholder="' + this.esc(this.label('emailPlaceholder')) + '" aria-label="' + this.esc(this.label('emailPlaceholder')) + '">' +
        '<label class="op-quiz__lead-consent"><input type="checkbox" required> <span>' + this.esc(this.label('emailConsent')) + '</span></label>' +
        '<button type="submit" class="op-res__cta">' + this.esc(this.label('emailButton')) + '</button>' +
        '<p class="op-quiz__lead-msg" role="status"></p>';
      this.bodyEl.appendChild(wrap);

      wrap.addEventListener('submit', (event) => {
        event.preventDefault();
        const email = wrap.querySelector('input[type="email"]').value.trim();
        const consent = wrap.querySelector('input[type="checkbox"]').checked;
        const msg = wrap.querySelector('.op-quiz__lead-msg');
        fetch(this.api + '/quiz/lead', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email, consent: consent, answers: this.answers }),
        })
          .then((res) => {
            if (!res.ok) throw new Error('API respondió ' + res.status);
            wrap.innerHTML = '<p class="op-quiz__lead-msg" role="status">' + this.esc(this.label('emailThanks')) + '</p>';
          })
          .catch(() => {
            msg.textContent = this.label('emailError');
          });
      });
    }

    renderResults(data) {
      const results = data.results || [];
      const restart =
        '<button type="button" class="op-quiz__back" data-restart>' + this.esc(this.label('restartLabel')) + '</button>';

      if (results.length === 0) {
        const wa = data.whatsapp_url
          ? '<a class="op-res__cta" href="' + this.esc(data.whatsapp_url) + '" target="_blank" rel="noopener">' + this.esc(this.label('whatsappLabel')) + '</a>'
          : '';
        this.bodyEl.innerHTML =
          '<h3 class="op-quiz__question">' + this.esc(this.label('emptyTitle')) + '</h3>' +
          '<p class="op-quiz__status">' + this.esc(this.label('emptyText')) + '</p>' + wa + restart;
      } else {
        this.bodyEl.innerHTML =
          '<h3 class="op-quiz__question">' + this.esc(this.label('resultTitle')) + '</h3>' +
          '<div class="op-res__grid op-quiz__results">' + results.map((p) => this.card(p)).join('') + '</div>' + restart;
      }
      const again = this.bodyEl.querySelector('[data-restart]');
      if (again) again.addEventListener('click', () => this.open());
      if (this.dataset.collectEmail === 'true') this.renderEmailForm();
    }
  }

  customElements.define('op-quiz-olfativo', OpQuizOlfativo);
}
